export const softValidateEmail = (email: string) => {
  const firstPartEmail = email.substring(0, email.indexOf('@'));

  const emailRegex = /.*(?:sales|info|admin|team|help).*/i;

  const emailIsValid = !firstPartEmail.match(emailRegex);

  return emailIsValid;
};
